import { useRecoilValue } from "@workflows/runtime-web";
import { dcocomComplaintIntakeFormIsPersonalComplaint } from "~/dcocom/workflows/complaint/DcocomCreateComplaintState";
export const useComplaintIntakeFormURLs = (): string[] => {
  const isOnBehalf = useRecoilValue(dcocomComplaintIntakeFormIsPersonalComplaint);
  const intakeFormURLs = ["/", "/complaint/on-behalf"];
  if (!isOnBehalf) {
    intakeFormURLs.push("/complaint/representative-data");
  }
  intakeFormURLs.push(...["/complaint/complainant-data", "/complaint/content", "/complaint/submit", "/complaint/success"]);
  return intakeFormURLs;
};